export enum Path {
  CART = '/cart',
  SHOP = '/shop',
  ONBOARDING = '/onboarding',
  ORDERS = '/orders',
  ACCOUNT = '/account',
}